<template>
  <div>
    <PCNavbar selectIndex="15"/>
    <MobileNavBar :currentActive="14" />
    <complianceProductionCategory/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import complianceProductionCategory from '@/components/service_compliance_production_category-4/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    complianceProductionCategory
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>